import { API_AUTH } from "./common";

const DoiTinhTrangNoApi = {
  postDoiTinhTrangNo: ({ share, debtLevel, chovayId }) =>
    API_AUTH.post(
      `quan-ly-cho-vay/doi-trang-thai-no?chovayId=${chovayId}&debtLevel=${debtLevel}&share=${share}`,
      {}
    ),
  getListTinhTrangNo: () => {
    return API_AUTH.get(`he-thong/list-debt-status`, {});
  },
};

export default DoiTinhTrangNoApi;
